import {HealthGuideServicesTypeEnum} from 'presentation/constants';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useAccountInformation, useQueryParams} from 'presentation/pages';
import React, {Fragment} from 'react';

import {EarlyAccessAlert} from '../EarlyAccessAlert';
import {ExamAlert} from '../ExamAlert';
import {ProvidersResultsV3} from './components/ProvidersResultsV3';

export function HealthProvidersResultsV3() {
	const {isEarlyAccess} = useAccountInformation();
	const {SEARCH_PARAMS} = useQueryParams();

	const {serviceType, comingFrom} = SEARCH_PARAMS;

	const showExamAlert =
		comingFrom === FlowEnum.EXAM &&
		serviceType === HealthGuideServicesTypeEnum.AUXILIARY_SERVICES;

	return (
		<Fragment>
			{showExamAlert ? <ExamAlert /> : null}
			{isEarlyAccess ? <EarlyAccessAlert /> : null}

			<ProvidersResultsV3 />
		</Fragment>
	);
}
